import { render } from "./RatingInput.vue?vue&type=template&id=1e393bf8"
import script from "./RatingInput.vue?vue&type=script&lang=js"
export * from "./RatingInput.vue?vue&type=script&lang=js"

import "./RatingInput.vue?vue&type=style&index=0&id=1e393bf8&lang=css"
script.render = render

export default script